import {
  dateFromISOWithProjectTimezone,
  dateToISOWithProjectTimezone
} from 'shared/entities/date';

import { DateVarType, VarType } from '../server';

export const normalizeDateVarValue = (
  value: string | null | undefined,
  type: DateVarType | undefined,
  timezone?: string | null
): Date | null => {
  if (!value) {
    return null;
  }

  if (type === VarType.date) {
    return dateFromISOWithProjectTimezone(value, timezone);
  }

  return new Date(value);
};

export const serializeDateVarValue = (
  value: Date | null | undefined,
  type: DateVarType,
  timezone?: string | null
): string | null => {
  if (!value) {
    return null;
  }

  if (type === VarType.date) {
    return dateToISOWithProjectTimezone(value, timezone);
  }

  return value.toISOString();
};
